
export default {
  name: 'navMobile',
  watch: {
    isMenuOpen: {
      handler: function(val) {
        try {
          if (val) {
            document.documentElement.classList.add('no-scroll');
          } else {
            document.documentElement.classList.remove('no-scroll');
          }
        } catch(error) {
          console.log(error)
        }
      }
    }
  },
  props: {
    isMenuOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeOutside() {
      this.$emit('close')
    }
  },
  directives: {
    "click-outside": {
      bind(el, binding, vNode) {
        const handleClick = event => {
          const isComponentClicked = el.contains(event.target);
          const isImageClicked = vNode.context.$refs.component.contains(event.target);
          if (!isComponentClicked && !isImageClicked) {
             // 如果点击的是关闭开启的按钮，则不做处理
            if(event.target._prevClass && event.target._prevClass.includes('nav-menu-button-switch')) {
              return
            }
            vNode.context[binding.expression]();
          }
        };

        const handleEscapeKey = event => {
          if (event.key === "Escape") {
            vNode.context[binding.expression]();
          }
        };

        document.addEventListener("click", handleClick);
        document.addEventListener("keydown", handleEscapeKey);

        el.handleClick = handleClick;
        el.handleEscapeKey = handleEscapeKey;
      },
      unbind(el) {
        document.removeEventListener("click", el.handleClick);
        document.removeEventListener("keydown", el.handleEscapeKey);
      }
    }
  }
}
